import { useQuery, useMutation, useLazyQuery, QueryHookOptions, MutationHookOptions, LazyQueryHookOptions, DocumentNode, OperationVariables } from "@apollo/client"
import { useGraphQLClient } from "../providers/DualGraphQLProvider"

// Enhanced hooks that accept endpoint parameter
export function useQueryWithEndpoint<TData = any, TVariables extends OperationVariables = any>(
  query: DocumentNode,
  options?: QueryHookOptions<TData, TVariables>,
  endpoint: "primary" | "legacy" = "legacy",
) {
  const client = useGraphQLClient(endpoint)
  return useQuery<TData, TVariables>(query, {
    ...options,
    client,
  })
}

export function useMutationWithEndpoint<TData = any, TVariables extends OperationVariables = any>(
  mutation: DocumentNode,
  options?: MutationHookOptions<TData, TVariables>,
  endpoint: "primary" | "legacy" = "legacy",
) {
  const client = useGraphQLClient(endpoint)
  return useMutation<TData, TVariables>(mutation, {
    ...options,
    client,
  })
}

export function useLazyQueryWithEndpoint<TData = any, TVariables extends OperationVariables = any>(
  query: DocumentNode,
  options?: LazyQueryHookOptions<TData, TVariables>,
  endpoint: "primary" | "legacy" = "legacy",
) {
  const client = useGraphQLClient(endpoint)
  return useLazyQuery<TData, TVariables>(query, {
    ...options,
    client,
  })
}

// Re-export the client hook for convenience
export { useGraphQLClient } from "@hydrologiq/shared/providers/DualGraphQLProvider"
